import { cx } from './cx';

/**
 * A currentColor spinner sized in `em` so it scales with the surrounding text.
 * Used inside Button's loading state and anywhere a small inline busy cue is
 * needed. For a full-area loading placeholder use Skeleton instead.
 */
export function Spinner({
  className,
  label = 'Loading',
}: {
  className?: string;
  label?: string;
}) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cx(
        'inline-block h-[1em] w-[1em] animate-spin rounded-full',
        'border-2 border-current border-r-transparent',
        className,
      )}
    />
  );
}
